module.exports = __webpack_public_path__ + "img/icon-phone.137482c4.svg";